import { range } from "lodash";

/**
 * Returns the unique elements of the array based on an equality function
 * Name is based on lodash _.uniqWith
 *
 * @param array
 * @param areEqual Returns true if the elements are considered equal. Only el1 will be kept in that case.
 */
export function uniqWith<T>(
  array: readonly T[],
  areEqual: (e1: T, e2: T) => boolean
): T[] {
  const empty_array: T[] = [];

  return array.reduce<T[]>((unique_elements, current_element) => {
    if (!unique_elements.some(el => areEqual(el, current_element))) {
      unique_elements.push(current_element);
    }
    return unique_elements;
  }, empty_array);
}

export function createArrayOfLength(n: number): number[] {
  const size = n > 0 ? Math.round(n) : 0;
  return new Array(size).fill(0);
}

export function mergeArraysReplacingByKey<T>(
  initial_array: Array<T>,
  array_to_merge: Array<T>,
  key: keyof T
): T[] {
  const merged_array = [...initial_array];
  for (const item_to_merge of array_to_merge) {
    const index = merged_array.findIndex(
      item => item[key] === item_to_merge[key]
    );
    if (index !== -1) {
      merged_array[index] = item_to_merge;
    } else {
      merged_array.push(item_to_merge);
    }
  }
  return merged_array;
}

export function transpose<T>(matrix: readonly (readonly T[])[]): T[][] {
  if (matrix.length === 0) {
    return [];
  }
  const max_col_number = Math.max(...matrix.map(a => a.length));

  return range(0, max_col_number).map(colIdx => {
    return matrix.reduce<T[]>((acc, row) => {
      if (colIdx < row.length) {
        // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
        acc.push(row[colIdx]);
      }

      return acc;
    }, []);
  });
}
